module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-solid-900.ttf?977e6fae30d6f3f1aed9997f1928f70d";